import React from "react";
import SEO from "../components/SEO";
import faqData from "../data/faq.json";

export default function FAQ() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={faqData.seo?.title}
        description={faqData.seo?.description}
        ogType="website"
        faqItems={faqData.items}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {faqData.eyebrow}
        </p>
        <h1 className="page-title mt-3">{faqData.title}</h1>
        <p className="mt-4 text-lg text-slate-600">{faqData.subtitle}</p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-4">
          {/* <!-- Replace with dynamic content from JSON --> */}
          {faqData.items.map((item) => (
            <div key={item.question} className="card p-6">
              <h2 className="text-base font-semibold text-slate-900">
                {item.question}
              </h2>
              <p className="mt-2 text-sm text-slate-600">{item.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
